export default __webpack_public_path__ + "static/cafe_36045-90a44a1c6c53f5fc6ec8bd7bf99410a4.png";